import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { EmployeeService } from '../services/employee.service';
import { UserService } from '../services/user.service';
import { Employee } from '../models/employee.model';
import { User } from '../models/user.model';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';

@Component({
  selector: 'employee',
  templateUrl: '../views/admin/employee.html',
  providers: [EmployeeService, UserService]
})
export class EmployeeComponent{
  public title: string;
  public employees: Employee[];
  public submitEmployeeModel: Employee;
  public users: User[];
  public message: any;
  public mode: string;
  public wait:boolean;
  public customerPrivilege:number;
  public privileges:Privileges[];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private employeeService: EmployeeService,
    private userService: UserService,
    public sharedVariables: VariableService
  )
  {
      this.title = null;
      this.mode = "submit-add";
      this.submitEmployeeModel = new Employee(0,'','','','','',0);
      this.customerPrivilege = null;
      this.wait = true;
  }

  /*ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    if(this.sharedVariables.validSession()){
      this.getAllUsers();
      this.getAllEmployees();
    }
    else
      this.title = "Error, Sesión no iniciada";
  }*/
  ngOnInit()
  {
    console.log("mode",this.mode);
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
              if(this.sharedVariables.login){
                this.getPrivileges();
                console.log(this.privileges);
                setTimeout(()=> {
                                  if(this.customerPrivilege == 1){
                                    this.getAllUsers();
                                    this.getAllEmployees();
                                    this.wait = false;
                                  }
                                  else{
                                  this.title = "Permisos insuficientes para el usuario";
                                  this.wait=false;
                                }
                                },this.sharedVariables.timeToLoad);
    }
    else
      this.title = "Error, Sesión no iniciada";
    },this.sharedVariables.sessionTime);
  }

  getAllEmployees()
  {
    this.employeeService.getEmployees().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.employees = result.data;
          console.log(this.employees);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  getAllUsers()
  {
    this.userService.getUsers().subscribe(
      result => {
        if(result.code != 200)
        {
          console.log(result);
        }else{
          this.users = result.data;
          console.log("Load users",this.users);
        }
      },error => {
       console.log(<any>error);
      }
    );
  }

  onSubmit()
  {
    if(this.mode == "submit-add")
    {
      this.saveEmployee();
    }else{
      this.updateEmployee();
    }
    setTimeout(()=> {
                      this.message = null;
                    },3000);
    setTimeout(()=> {
                      this.getAllEmployees();
                      this.submitEmployeeModel = new Employee(0,'','','','','',0);
                    },500);
    this.mode = "submit-add";
    console.log("mode",this.mode);
  }

  saveEmployee()
  {
    this.employeeService.addEmployee(this.submitEmployeeModel).subscribe(
      response => {
        if(response.code == 200)
        {
          this.message = response.data;
        }else
        {
          console.log(response);
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  editEmployee(pEmployee: Employee)
  {
    this.mode = "submit-update";
    this.submitEmployeeModel = Object.assign({}, pEmployee);
    console.log("Checkout objects");
    console.log("mode ",this.mode);
  }

  updateEmployee()
  {
      let id = this.submitEmployeeModel.ID;
      console.log("objeto update ",this.submitEmployeeModel);
      this.employeeService.updateEmployee(id,this.submitEmployeeModel).subscribe(
        response => {
          if(response.code == 200)
          {
            this.message = response.data;
          }else
          {
            console.log(response);
          }
          },
          error => {
            console.log(<any>error);
          }
        );
  }

  deleteEmployee(id: number)
  {
    this.employeeService.deleteEmployee(id).subscribe(
        response => {
          if(response.code == 200){
            this.getAllEmployees();
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  cleanObject()
  {
    this.submitEmployeeModel = new Employee(0,'','','','','',0);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.customerPrivilege = response.data[0].Customer;
            console.log("Privilegios del usuario",this.customerPrivilege);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  showMessage()
  {
    this.message = "hola";
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/employee.component.ts